export default __webpack_public_path__ + "static/media/Certificate.ebc74d37.svg";